import type { ContactsLinksProps } from './types';
import type { DirectoryLinkListProps } from '../../DirectoryPanel/DirectoryListItem/DirectoryLinks/types';
import type { IconDefinition } from '../../shared/Icon';
import { observer } from 'mobx-react';
import * as React from 'react';
import { formatNumberWithNationalCode } from 'Utils/phoneUtil';

import { TextLink } from '../../shared/TextLink';

export const ContactsLinksObserver: React.FC<ContactsLinksProps> = ({
  contact,
  callWithPerson,
}) => {
  const testid = 'contactsLinks';

  const CONTACTS_LINKS: DirectoryLinkListProps = [
    ...(contact.phoneNumbers?.map(({ number }, index) => ({
      testid: `${testid}-linkCall${index}`,
      content: formatNumberWithNationalCode(number),
      icon: 'on-call' as IconDefinition,
      props: {
        onClick: (event: React.MouseEvent) => {
          event.stopPropagation();
          void callWithPerson(undefined, number);
        },
      },
    })) ?? []),
    ...(contact.emails?.map(({ address }, index) => ({
      testid: `${testid}-linkEmail${index}`,
      content: address,
      icon: 'message' as IconDefinition,
      props: {
        href: `mailto:${address}`,
        target: '_blank',
        onClick: (event: React.MouseEvent) => {
          event.stopPropagation();
        },
      },
    })) ?? []),
  ];

  return (
    <React.Fragment>
      {CONTACTS_LINKS.map(({ content, icon, testid, props }) =>
        content ? (
          <TextLink key={content} data-private {...{ icon, testid, ...props }}>
            {content}
          </TextLink>
        ) : null
      )}
    </React.Fragment>
  );
};

export const ContactsLinks = observer(ContactsLinksObserver);
